<template>
    <div id="delete-custom-luts-folder-modal" class="modal-new hidden">
        <span class="title">Delete folder</span>
        <p class="description">Are you sure you want to delete folder: <br />"<span>{{ folder.name }}</span>"?</p>
        <div class="buttons-continer">
            <v-btn @click="confirm" :disabled="processing" dark class="modal-btn --primary --delete">
                <v-progress-circular v-if="processing" color="#fff" indeterminate size="18" width="3" />
                <template v-else>Delete</template>
            </v-btn>
            <button @click="close" type="button" class="modal-btn --cancel">Cancel</button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { toString } from "lodash";

export default {
    data() {
        return {
            processing: false
        }
    },

    computed: {
        ...mapState('UserFilesCustomLuts', ['folder'])
    },

    methods: {
        async confirm() {
            this.processing = true;
            await this.$store.dispatch('UserFilesCustomLuts/deleteFolder', this.folder.id);
            await this.$store.dispatch('UserFilesCustomLuts/index');

            for await (const lut of this.folder.files) {
                await customLutsStore.removeItem(toString(lut.id));
                window.lutPreviewer.removeCustomLutPreview(lut.id);
            }

            if (window.lutify.getActiveBlock().folder.id == this.folder.id) {
                window.UI.hideLUTtemplates();
            }

            window.lutPreviewer.render();

            this.$store.commit('UserFilesCustomLuts/SET_CUSTOM_LUTS_FOLDER', {
                id: null,
                name: null,
                files: []
            })

            this.processing = false;
            this.close();
        },
        close() {
            window.UI.hideModal();
            window.UI.showModal(window.UI.modals.customLUT.edit.el);
        }
    }
};
</script>
